<formio-loader></formio-loader>
<div class="template-wrapper" [dir]="data.dir">
  <div class="row" *ngIf="!viewOnly">
    <div class="form-group col-sm-6">
      <label for="template-resource" [ngClass]="{'field-required': required}">{{ 'forms.common.' + resource |
        translate}}</label>
      <ng-select [items]="templates" bindLabel="value" appearance="outline" [(ngModel)]="selectedTemplate"
        [disabled]="viewOnly" (change)="changeTemplate($event)" [required]="required">
      </ng-select>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-sm-6" *ngIf="evaluatedTemplate && !viewOnly" (click)="editTemplate(evaluatedTemplate)">
      <div class="file-container">
        <div>
          <span class="file"></span>
          <a>{{ selectedTemplate.template.originalName}}</a>
        </div>
        <span class="edit-file"></span>
      </div>
    </div>
    <div class="form-group col-sm-6" *ngIf="evaluatedTemplate">
      <div class="eval-file-container">
        <div>
          <span class="file"></span>
          <a>{{ evaluatedTemplateName}}</a>
        </div>
        <div class="d-flex gap-1">
          <span class="__download-file pi pi-download" (click)="downloadTemplateFile()"></span>
          <span class="__view-file pi pi-eye" (click)="viewTemplateFile()"></span>
        </div>
      </div>
    </div>
  </div>
</div>
